import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative z-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 lg:px-6" }
const _hoisted_3 = { class: "flex items-center justify-between h-10" }
const _hoisted_4 = { class: "flex items-center gap-6" }
const _hoisted_5 = {
  class: "inline-flex items-center gap-2 hover:text-slate-800 transition",
  href: "tel:+97332141440"
}
const _hoisted_6 = {
  key: 0,
  class: "glass-overlay--frozen",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "flex items-center h-20 relative z-10" }
const _hoisted_8 = {
  class: "hidden md:flex items-center mx-auto uppercase text-[15px] text-slate-700",
  "aria-label": "Primary"
}
const _hoisted_9 = { class: "flex items-center gap-8" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "hidden md:flex items-center gap-3 ml-auto" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = {
  key: 0,
  class: "absolute right-0 mt-2 min-w-[180px] bg-white border border-gray-100 rounded-xl shadow-lg py-2 z-[70]",
  role: "menu"
}
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = { class: "h-8 w-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-semibold" }
const _hoisted_17 = {
  key: 0,
  class: "absolute right-0 mt-2 w-48 overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 z-[70]",
  role: "menu"
}
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = {
  key: 0,
  class: "fixed top-0 right-0 h-full w-[86%] max-w-sm z-[70] bg-white/85 supports-[backdrop-filter]:backdrop-blur-2xl shadow-2xl ring-1 ring-black/5 rounded-l-2xl flex flex-col overflow-hidden pointer-events-auto",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "mobileMenuTitle"
}
const _hoisted_20 = {
  "aria-label": "Mobile",
  class: "flex-1 overflow-y-auto"
}
const _hoisted_21 = { class: "px-2 py-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col gap-1 px-4 pt-1 pb-2"
}
const _hoisted_24 = { class: "px-5 pb-6 pt-3 border-t border-gray-200/70 bg-white/60" }
const _hoisted_25 = { class: "flex flex-col gap-2" }

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import router from '@/router'
import { isLoggedIn, logout } from '@/utils/common'

/* ===== REACTIVE AUTH ===== */

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const auth = ref(isLoggedIn())
const refreshAuth = () => { auth.value = isLoggedIn() }

/* ===== STATE ===== */
const isMenuOpen = ref(false)
const expandedItemId = ref<number | null>(null)
const openUserMenu = ref(false)
const showMobilePartner = ref(false)

/* ===== NAV ITEMS ===== */
const baseItems = [
  { id: 1, title: 'Home', component: 'Home' },
  { id: 2, title: 'About us', component: 'AboutUs' },
  { id: 3, title: 'Our services', component: 'OurServices' },
  { id: 4, title: 'Contact us', component: 'ContactUs' },
  { id: 5, title: 'FAQ', component: 'FAQ' }
]
const mobileMenu = computed(() => ([
  ...baseItems,
  { id: 6, title: auth.value ? 'My dashboard' : 'Log in', component: auth.value ? 'AccountDashboard' : 'Login' },
  { id: 7, title: 'Signup', component: null }
]))

/* ===== GREETING ===== */
const displayName = computed(() => {
  const u: any = auth.value?.user
  const name = u?.first_name || u?.name || (u?.email ? u.email.split('@')[0] : '')
  return name ? name.charAt(0).toUpperCase() + name.slice(1) : 'User'
})
const initials = computed(() => {
  const u: any = auth.value?.user
  const first = (u?.first_name || u?.name || '').trim()
  const last  = (u?.last_name || '').trim()
  if (first) return (first[0] + (last ? last[0] : '')).toUpperCase()
  const email = u?.email || ''
  return email ? email[0].toUpperCase() : 'U'
})

/* ===== HELPERS ===== */
const go = (name: string) => router.push({ name })
const handleTopNav = (item: any) => { if (item.component) router.push({ name: item.component }) }
const handleSignupRoute = (child: any) => { expandedItemId.value = null; router.push({ name: 'Signup', params: { type: child.type } }) }
const handleMenuItemClick = (item: any) => {
  if (item.component) { router.push({ name: item.component }); isMenuOpen.value = false }
  else if (item.id === 7) { router.push({ name: 'Signup', params: { type: 'web' } }); isMenuOpen.value = false }
}
const toggleSignup = () => { expandedItemId.value = expandedItemId.value === 6 ? null : 6 }
const togglePartnerMenu = () => { expandedItemId.value = expandedItemId.value === 'partner' ? null : 'partner' }
const showMobileSignup = ref(false)
const toggleMobileSignup = () => { showMobileSignup.value = !showMobileSignup.value }
const toggleMobilePartner = () => { showMobilePartner.value = !showMobilePartner.value }
const toggleUserMenu = () => (openUserMenu.value = !openUserMenu.value)
const nav = (path: string) => { openUserMenu.value = false; router.push(path) }
const handleLogout = async () => {
  openUserMenu.value = false
  await logout(router)
  refreshAuth()
}

/* ===== MOBILE MENU ===== */
const openMenu = () => (isMenuOpen.value = true)
const closeMenu = () => { isMenuOpen.value = false; expandedItemId.value = null }

/* ===== STICKY NAV ===== */
const topBarRef = ref<HTMLElement | null>(null)
const navWrapRef = ref<HTMLElement | null>(null)
const isFixed = ref(false)
const navHeight = ref(80)
let observer: IntersectionObserver | null = null
const measure = () => { if (navWrapRef.value) navHeight.value = navWrapRef.value.getBoundingClientRect().height || 80 }

const closeAllMenus = () => {
  expandedItemId.value = null
  openUserMenu.value = false
}

onMounted(async () => {
  await nextTick()
  measure()
  observer = new IntersectionObserver(entries => { isFixed.value = !entries[0].isIntersecting }, { threshold: 0 })
  if (topBarRef.value) observer.observe(topBarRef.value)
  window.addEventListener('resize', measure, { passive: true })
  window.addEventListener('click', closeAllMenus)
})
onBeforeUnmount(() => {
  if (observer && topBarRef.value) observer.unobserve(topBarRef.value)
  window.removeEventListener('resize', measure)
  window.removeEventListener('click', closeAllMenus)
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 z-[60]",
          onClick: closeMenu
        }))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", {
        ref_key: "topBarRef",
        ref: topBarRef,
        class: "hidden md:block border-b border-gray-100 text-slate-600 text-[14px] bg-white"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("a", {
                class: "inline-flex items-center gap-2 hover:text-slate-800 transition",
                href: "https://maps.google.com/?q=312 Falcon Tower Diplomatic Area, Manama, Kingdom of Bahrain",
                target: "_blank",
                rel: "noopener"
              }, [
                _createElementVNode("span", { class: "font-icon theme-icon location-icon text-slate-500 text-[16px]" }),
                _createElementVNode("span", { class: "truncate" }, "312 Falcon Tower Diplomatic Area, Manama, Kingdom of Bahrain")
              ], -1)),
              _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: "fa-solid fa-mobile-screen",
                  class: "text-slate-500"
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-medium" }, "+973 3214 1440", -1))
              ])
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "inline-flex items-center gap-2" }, [
              _createElementVNode("span", { class: "font-icon theme-icon clock-icon text-slate-500 text-[16px]" }),
              _createElementVNode("span", null, "24/7 Available")
            ], -1))
          ])
        ])
      ], 512),
      _createElementVNode("div", {
        style: _normalizeStyle({ height: isFixed.value ? navHeight.value + 'px' : '0px' })
      }, null, 4),
      _createElementVNode("div", {
        ref_key: "navWrapRef",
        ref: navWrapRef,
        class: _normalizeClass([
        isFixed.value ? 'fixed top-3 left-0 right-0 z-[55] pointer-events-none' : 'relative',
        'nav-transition'
      ])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
          'relative',
          'max-w-7xl mx-auto px-4 lg:px-6',
          'pointer-events-auto card-transition',
          isFixed.value
            ? 'glass--frozen rounded-2xl ring-1 ring-white/60 shadow-xl translate-y-0 scale-[0.985] opacity-100'
            : 'translate-y-0 scale-100 opacity-100'
        ])
        }, [
          (isFixed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (go('Home'))),
              class: "shrink-0 focus:outline-none",
              "aria-label": "Go to home"
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: "/assets/logo.png",
                alt: "Vehitra World",
                class: "h-12 w-auto md:h-14",
                width: "180",
                height: "56"
              }, null, -1)
            ])),
            _createElementVNode("nav", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(baseItems, (item) => {
                  return _createElementVNode("li", {
                    key: item.id,
                    class: "relative group"
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (handleTopNav(item)),
                      class: "inline-flex items-center gap-1 tracking-wide hover:text-slate-900 focus-visible:outline-none"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], 8, _hoisted_10),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "absolute -bottom-2 left-0 h-[2px] w-0 bg-emerald-500 transition-all duration-300 group-hover:w-full" }, null, -1))
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (!auth.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (go('Login'))),
                      class: "px-4 py-2 text-[14px] font-medium rounded-xl border border-gray-200 hover:bg-gray-50"
                    }, " Log in "),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(toggleSignup, ["stop"]),
                        class: "px-4 py-2 text-[14px] font-medium rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 flex items-center gap-1 transition-all",
                        "aria-haspopup": "menu",
                        "aria-expanded": expandedItemId.value === 6 ? 'true' : 'false'
                      }, _cache[16] || (_cache[16] = [
                        _createElementVNode("span", null, "Signup", -1),
                        _createElementVNode("svg", {
                          class: "h-4 w-4 text-white/80",
                          viewBox: "0 0 20 20",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", { d: "M5.25 7.5l4.5 4.5 4.5-4.5h-9z" })
                        ], -1)
                      ]), 8, _hoisted_13),
                      (expandedItemId.value === 6)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("button", {
                              class: "block w-full text-left px-4 py-2 text-[14px] hover:bg-gray-50 border-b border-gray-50",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSignupRoute({ type: 'web' })))
                            }, " User "),
                            _createElementVNode("button", {
                              class: "block w-full text-left px-4 py-2 text-[14px] hover:bg-gray-50",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSignupRoute({ type: 'agent' })))
                            }, " Agency ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "relative",
                    onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (openUserMenu.value = false), ["escape"]))
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _withModifiers(toggleUserMenu, ["stop"]),
                      class: "inline-flex items-center gap-2 rounded-xl border border-gray-200 px-3 py-2 text-[14px] font-medium hover:bg-gray-50",
                      "aria-haspopup": "menu",
                      "aria-expanded": openUserMenu.value ? 'true' : 'false'
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(initials.value), 1),
                      _createElementVNode("span", null, "Hello, " + _toDisplayString(displayName.value), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("svg", {
                        class: "h-4 w-4 text-slate-500",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M5.25 7.5l4.5 4.5 4.5-4.5h-9z" })
                      ], -1))
                    ], 8, _hoisted_15),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (openUserMenu.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (auth.value?.user?.type !== 'web')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (nav('/account/dashboard'))),
                                    class: "block w-full px-4 py-2 text-left text-[14px] text-slate-700 hover:bg-gray-50"
                                  }, " Dashboard "))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (nav(`/${auth.value?.user?.type}/bookings`))),
                                class: "block w-full px-4 py-2 text-left text-[14px] text-slate-700 hover:bg-gray-50"
                              }, " View orders "),
                              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "my-1 border-t border-slate-100" }, null, -1)),
                              _createElementVNode("button", {
                                onClick: handleLogout,
                                class: "block w-full px-4 py-2 text-left text-[14px] text-red-600 hover:bg-red-50"
                              }, " Logout ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 32)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSignupRoute({ type: 'supplier' }))),
                  class: "px-5 py-2 rounded-full bg-green-700 text-white text-[15px] font-semibold shadow hover:bg-green-800 transition flex items-center gap-1"
                }, _cache[19] || (_cache[19] = [
                  _createElementVNode("span", null, "Partner", -1)
                ]))
              ])
            ]),
            _createElementVNode("button", {
              class: "md:hidden ml-auto p-2 rounded-lg border border-gray-200 bg-white/70",
              onClick: openMenu,
              "aria-label": "Open menu"
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M3 6h18M3 12h18M3 18h18",
                  stroke: "#334155",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))
          ]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "slide-menu" }, {
              default: _withCtx(() => [
                (isMenuOpen.value)
                  ? (_openBlock(), _createElementBlock("aside", _hoisted_19, [
                      _createElementVNode("div", { class: "flex items-center justify-between px-5 py-4 border-b border-gray-200/70" }, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", {
                          class: "text-slate-800 font-semibold tracking-wide uppercase text-[13px]",
                          id: "mobileMenuTitle"
                        }, "Menu", -1)),
                        _createElementVNode("button", {
                          onClick: closeMenu,
                          class: "p-2 rounded-lg bg-white/60 hover:bg-white transition",
                          "aria-label": "Close menu"
                        }, _cache[21] || (_cache[21] = [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M6 6l12 12M18 6L6 18",
                              stroke: "#0f172a",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            })
                          ], -1)
                        ]))
                      ]),
                      _createElementVNode("nav", _hoisted_20, [
                        _createElementVNode("ul", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileMenu.value, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.id
                            }, [
                              (item.id !== 7)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "w-full text-left px-4 py-3 rounded-xl text-[15px] text-slate-800 hover:bg-white border border-transparent hover:border-gray-200 active:scale-[0.99] transition",
                                    onClick: ($event: any) => (handleMenuItemClick(item))
                                  }, _toDisplayString(item.title), 9, _hoisted_22))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("button", {
                                      onClick: toggleMobileSignup,
                                      class: "w-full flex items-center justify-between px-4 py-3 rounded-xl text-[15px] text-slate-800 hover:bg-white border border-transparent hover:border-gray-200 active:scale-[0.99] transition"
                                    }, [
                                      _cache[23] || (_cache[23] = _createElementVNode("span", null, "Signup", -1)),
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: showMobileSignup.value ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
                                        class: "text-[12px] opacity-80"
                                      }, null, 8, ["icon"])
                                    ]),
                                    (showMobileSignup.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _createElementVNode("button", {
                                            class: "w-full text-left px-4 py-2 rounded-lg bg-gray-50 text-[14px] text-slate-800",
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => {handleSignupRoute({ type: 'web' }); isMenuOpen.value = false})
                                          }, " User "),
                                          _createElementVNode("button", {
                                            class: "w-full text-left px-4 py-2 rounded-lg bg-gray-50 text-[14px] text-slate-800",
                                            onClick: _cache[9] || (_cache[9] = ($event: any) => {handleSignupRoute({ type: 'agent' }); isMenuOpen.value = false})
                                          }, " Agency ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => {handleSignupRoute({ type: 'supplier' }); isMenuOpen.value = false}),
                            class: "block w-full text-center px-5 py-3 rounded-full bg-green-700 text-white font-semibold shadow hover:bg-green-800 transition flex items-center justify-center gap-2"
                          }, _cache[24] || (_cache[24] = [
                            _createElementVNode("span", null, "Partner", -1)
                          ]))
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex items-center justify-center gap-4 mt-3 text-slate-500 text-[13px]" }, [
                          _createElementVNode("a", {
                            href: "tel:+97332141440",
                            class: "hover:text-slate-700"
                          }, "+973 3214 1440"),
                          _createElementVNode("span", { "aria-hidden": "true" }, "•"),
                          _createElementVNode("span", null, "24/7 Available")
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        ], 2)
      ], 2)
    ])
  ], 64))
}
}

})